import { render, staticRenderFns } from "./apply-to-join.vue?vue&type=template&id=2a6f4bf8&scoped=true"
import script from "./apply-to-join.vue?vue&type=script&lang=js"
export * from "./apply-to-join.vue?vue&type=script&lang=js"
import style0 from "./apply-to-join.vue?vue&type=style&index=0&id=2a6f4bf8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6f4bf8",
  null
  
)

export default component.exports